import React from 'react';
import * as Styles from './BlockOptionsV2.styles';
import { Button } from 'gatorcomponents';

const BlockOptionsV2 = ({
  icon,
  title,
  description,
  subtitle,
  buttonLabel,
  buttonClick,
  buttonTestId = 'block-options-button',
  badge,
}) => (
  <Styles.Block>
    <Styles.BlockHeader>

      <Styles.BadgeWrapper>
        {badge && (
          <>
            <Styles.Badge>{badge}</Styles.Badge>
            {icon}
          </>
        )}
      </Styles.BadgeWrapper>

      <Styles.TitleWrapper>
        {title && <Styles.Title>{title}</Styles.Title>}
        {!badge && icon}
      </Styles.TitleWrapper>
      {subtitle && <Styles.Subtitle>{subtitle}</Styles.Subtitle>}
    </Styles.BlockHeader>
    {description && <Styles.Description>{description}</Styles.Description>}
    {buttonLabel && (
      <Styles.ButtonWrapper>
        <Button
          testId={buttonTestId}
          iconLeft={null}
          label={buttonLabel}
          title={buttonLabel}
          size="medium2"
          variant="secondary"
          iconRight={null}
          width="fit-content"
          onClick={buttonClick}
        />
      </Styles.ButtonWrapper>
    )}
  </Styles.Block>
);

export default BlockOptionsV2;
